// Copied from https://github.com/wix-private/premium-purchase/blob/master/packages/checkout-form/src/components/FormControls/validators/taxValidators/israelVatIdValidator.ts

/*
 * Luhn algorithm checksum
 * copied and modified from https://gist.github.com/ShirtlessKirk/2134376
 */
const luhnChk = function (ccNum) {
  const arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  let len = ccNum.length,
    bit = 1,
    sum = 0,
    val;
  while (len) {
    val = parseInt(ccNum.charAt(--len), 10);
    // eslint-disable-next-line
    sum += (bit ^= 1) ? arr[val] : val;
  }
  return !!(sum && sum % 10 === 0);
};
export const israelVatIdValidator = value => {
  var _value$id;
  // should be only digits, should have length between 5-9
  if (!/^[0-9]{5,9}$/.test(value == null ? void 0 : value.id)) {
    return false;
  }

  // should pass luhn test when padded with zeros
  const padded = value == null || (_value$id = value.id) == null ? void 0 : _value$id.padStart(9, '0');
  if (!luhnChk(padded)) {
    return false;
  }
  return true;
};
//# sourceMappingURL=israel-vat-id-validator.js.map